import { render, staticRenderFns } from "./ChecklistTemplateModal.vue?vue&type=template&id=08b963ab&scoped=true"
import script from "./ChecklistTemplateModal.vue?vue&type=script&lang=js"
export * from "./ChecklistTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./ChecklistTemplateModal.vue?vue&type=style&index=0&id=08b963ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b963ab",
  null
  
)

export default component.exports